export default __webpack_public_path__ + "static/media/q-contact-rdebt.c68b3383.png";